import { render, staticRenderFns } from "./AuditorDetails.vue?vue&type=template&id=5f56b22b&scoped=true&"
import script from "./AuditorDetails.vue?vue&type=script&lang=ts&"
export * from "./AuditorDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AuditorDetails.vue?vue&type=style&index=0&id=5f56b22b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56b22b",
  null
  
)

export default component.exports